import React from 'react';
import type { AppProps } from 'next/app';
import dynamic from 'next/dynamic';
import { appWithTranslation } from 'next-i18next';
import { FrontasticProvider } from '@frontastic-engbers/lib';
import '../styles/app.scss';
import '../styles/themes/default.scss';
import '../styles/themes/theme1.scss';
import '../styles/components/slider.css';
import '../styles/components/default-loader.css';
import { AnimatePresence } from 'framer-motion';

const ToasterComponentDynamic = dynamic(() => import('@engbers/components/online-shops/commercetools-ui/toaster'), {
  ssr: false,
});

function FrontasticStarter({ Component, pageProps, router }: AppProps) {
  return (
    <FrontasticProvider
      context={{
        type: 'pwa',
      }}
    >
      <AnimatePresence mode="wait">
        <Component key={router.asPath} {...pageProps} />
        <ToasterComponentDynamic />
      </AnimatePresence>
    </FrontasticProvider>
  );
}

export default appWithTranslation(FrontasticStarter);
